(function () {
  if (window.wikaSectionRefreshLoaded) return;
  window.wikaSectionRefreshLoaded = true;

  const context = window.wikaDataClosureContext || {};
  const pageType = context.page_type || '';

  if (window.Shopify && window.Shopify.designMode) return;
  if (!['product', 'collection', 'index'].includes(pageType)) return;

  const sectionPrefix = 'shopify-section-';

  function sectionIdFromElement(section) {
    if (!section || !section.id || !section.id.startsWith(sectionPrefix)) return '';
    return section.id.slice(sectionPrefix.length);
  }

  function imageFiles(root) {
    const files = [];
    const imageRoot = pageType === 'product' ? root.querySelector('media-gallery') || root : root;
    imageRoot.querySelectorAll('img').forEach((image) => {
      const sources = pageType === 'product' ? [image.src] : [image.currentSrc, image.src];
      sources.forEach((src) => addFile(src, files));
      (image.getAttribute('srcset') || '')
        .split(',')
        .forEach((candidate) => addFile(candidate.trim().split(/\s+/)[0], files));
    });
    return files;
  }

  function addFile(src, files) {
    if (!src) return;
    try {
      const url = new URL(src, window.location.origin);
      const file = url.pathname.split('/').pop();
      if (file && /\.(jpe?g|png|webp|gif)$/i.test(file)) files.push(file);
    } catch (error) {
      return;
    }
  }

  function imageKey(root) {
    return imageFiles(root).slice(0, 36).join('|');
  }

  function findCandidates() {
    const sections = Array.from(document.querySelectorAll(`[id^="${sectionPrefix}"]`));

    if (pageType === 'product') {
      return sections.filter((section) => section.querySelector('product-info media-gallery'));
    }

    if (pageType === 'collection') {
      return sections.filter((section) => section.querySelector('#ProductGridContainer, .product-grid'));
    }

    return sections
      .filter((section) => section.querySelector('.card-wrapper a[href*="/products/"], .product-card-wrapper a[href*="/products/"]'))
      .slice(0, 6);
  }

  async function fetchSection(sectionId) {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('wika_section_refresh', Date.now().toString());

    const response = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html,*/*' },
    });

    if (!response.ok) return null;
    const markup = await response.text();
    if (!markup || markup.length < 100) return null;

    const doc = new DOMParser().parseFromString(markup, 'text/html');
    return doc.getElementById(`${sectionPrefix}${sectionId}`) || doc.body.firstElementChild;
  }

  async function refreshSection(section) {
    const sectionId = sectionIdFromElement(section);
    if (!sectionId || section.dataset.wikaSectionRefreshed === 'true') return;

    section.dataset.wikaSectionRefreshed = 'true';
    const currentKey = imageKey(section);

    try {
      const freshSection = await fetchSection(sectionId);
      if (!freshSection) return;

      const freshKey = imageKey(freshSection);
      if (!freshKey || freshKey === currentKey) return;

      section.replaceWith(freshSection);
      document.dispatchEvent(
        new CustomEvent('wika:section-refresh', {
          detail: { sectionId, pageType },
        })
      );
    } catch (error) {
      return;
    }
  }

  function refreshStaleSections() {
    findCandidates().forEach((section) => refreshSection(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshStaleSections, { once: true });
  } else {
    refreshStaleSections();
  }
})();
